<div class="flex">
    <div class="mr-2">
        <button
        pButton
        class="split-button-orange-1"
        type="button"
        label="Data"
        ></button>
    </div>   
    <div class="mr-2">
        <button
        pButton
        class="mr-2"
        class="split-button-orange-1"
        type="button"
        label="Realizados"
        ></button>   
    </div>
    <div class="relative">
        <div id="btnProfessional">
            <button
                pButton
                class="split-button-orange-1"
                type="button"
                label="Profissional"
                (click)="profissionais.show()"
            ></button>
        </div>
        <p-multiSelect 
            #profissionais
            appendTo="btnProfessional"
            [styleClass]="'notVisitbleMultiselect'"
            [panelStyle]="'width:160px'"
            [filter]="false"
            [options]="cities" 
            [(ngModel)]="selectedCities" 
            placeholder="Select Cities" 
            optionLabel="name" 
            [showHeader]="false">
            <ng-template pTemplate="footer">
                <div class="w-100 flex justify-content-center pb-4">
                    <button
                        style="background-color:#FF8321 !important;color:white !important"
                        pButton
                        class="mr-2"
                        class="split-button-orange-1"
                        pRipple
                        type="button"
                        label="Aplicar"
                    ></button>   
                </div>
            </ng-template>
        </p-multiSelect>
    </div>   
</div>


<div class="appointment-card-container">
    <div *ngFor="let color of colors" class="mb-4">
        <split-appointment-card 
        [title]="'Comprar carro'"
        [description]="'Danilo Araujo'" 
        [day]="'16 FEV'"
        [time]="'07:00'"
        [color]="color"
        [tooltip]="'Descrição detalhada do que é a tarefa'" 
        ></split-appointment-card>
    </div>
</div>